export const BASISURL = "https://www.anitas-nailstudio.com";
export default BASISURL;
